// extracted by mini-css-extract-plugin
export default {"popoverHeaderWrapper":"index-module__popoverHeaderWrapper--e0mXX","popoverHeaderBg":"index-module__popoverHeaderBg--nIsts"};